const HANDLER_IDS = {
    ProspectImportHandler: "Prospect",
    HighSchoolImportHandler: "HighSchool",
    PersonHighSchoolImportHandler: "PersonHighSchool",
    PersonPhoneImportHandler: "PersonPhone",
    PersonAddressImportHandler: "PersonAddress",
    PersonVeteranTypeImportHandler: "PersonVeteranStatus",
    CustomImportHandler: "Custom",
};
export default class ImportProcessHandlerDomainService {
    static get ProspectImportHandlerId() {
        return HANDLER_IDS.ProspectImportHandler;
    }
    static get HighSchoolImportHandlerId() {
        return HANDLER_IDS.HighSchoolImportHandler;
    }
    static get PersonHighSchoolImportHandlerId() {
        return HANDLER_IDS.PersonHighSchoolImportHandler;
    }
    static get PersonPhoneImportHandlerId() {
        return HANDLER_IDS.PersonPhoneImportHandler;
    }
    static get PersonAddressImportHandlerId() {
        return HANDLER_IDS.PersonAddressImportHandler;
    }
    static get PersonVeteranTypeImportHandlerId() {
        return HANDLER_IDS.PersonVeteranTypeImportHandler;
    }
    static get CustomImportHandlerId() {
        return HANDLER_IDS.CustomImportHandler;
    }
    static getHandlerIds() {
        return Object.assign({}, HANDLER_IDS);
    }
}
